<template>
    <section class="padding-vertical-content" key="paso2" id="paso2">
        <div v-if="event.place.tipo_proceso_online === 1 || event.place.tipo_proceso_online === 2" class="container">
            <div class="row" v-if="!event.reserva_instalaciones">
                <div class="col-12" v-if="zona.with_seats">
                    <h2 class="m-0 h1 text-uppercase">{{ $t('partido.elige_asientos') }}</h2>
                    <h3 class="subtitle h3 light mb-3 ">{{ $t('partido.varios_asientos') }}</h3>
                </div>
                <div class="col-12" v-if="!zona.with_seats">
                    <h2 class="m-0 h1 text-uppercase">{{ $t('partido.elige_entradas') }}</h2>
                    <h3 class="subtitle h3 light mb-3 ">{{ $t('partido.varias_entradas') }}</h3>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-lg-4">
                    <div class="row">
                        <div class="col-12">
                            <div class="oswald text-uppercase">{{ $t('partido.zona_seleccionada') }}:</div>
                            <span class="h2 mb-1 d-block">
                                {{ zona.name }}
                                <br/>
                                <button
                                    @click="$emit('reset')"
                                    class="h6 button small-button m-0"
                                    :disabled="paso3"
                                >
                                    <i class="fa fa-redo"></i> {{ $t('partido.cambiar_zona') }}
                                </button>
                                <button
                                    v-if="zona.imagen_panoramica"
                                    @click="showModal('imagen-panoramica')"
                                    type="button"
                                    class="h6 button small-button m-0 ml-2"
                                >
                                    VER 360º
                                </button>
                            </span>
                            <ImagenPanoramica
                                v-if="zona.imagen_panoramica"
                                name="imagen-panoramica"
                                :url="this.zona.imagen_panorama"
                                title="Imagen panorámica de la zona"
                                @close="() => close(false)"
                            />

                            <div v-if="zona.imagen" class="mb-3"><img :src="zona.imagen"/></div>

                            <SelectorZonaComponent :zona="zona" :zonas="zonas" />

                            <TusAsientosComponent
                                :precios="zona.precios"
                                :asientos="asientos"
                                :event="event"
                                :puedo_cambiar="!paso3 && !pasoExtraRA"
                                :forzar_adyacentes="event.forzar_adyacentes"
                                :alguno_seleccionado="alguno_seleccionado"
                                :puedo_continuar="!paso3 && !pasoExtraRA"
                                :asientos_validos="asientos_validos"
                                :error_message="error_message"
                                :loading="paso2_loading"
                                @continuar="$emit('bloquearAsientos')"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-8 order-first order-lg-last">
                    <div v-if="zona.with_seats">
                        <template v-if="zona.lfp_id">
                            <AsientosLfpComponent
                                :zona="zona"
                                :asientos="asientos"
                                :asientos_maximos="asientos_maximos"
                                :puedo_cambiar="paso3 ? false : true"
                                :forzar_adyacentes="event.forzar_adyacentes"
                                :event="event"
                                @changeAnySelected="(value) => alguno_seleccionado = value"
                                @cargado="$emit('cargado')"
                                @validoAsientos="(data) => asientos_validos = data"
                            />
                        </template>
                        <template v-else>
                            <AsientosComponent
                                :key="reloadComponent"
                                :zona="zona"
                                :asientos="asientos"
                                :asientos_maximos="asientos_maximos"
                                :puedo_cambiar="paso3 ? false : true"
                                :forzar_adyacentes="event.forzar_adyacentes"
                                :event="event"
                                @changeAnySelected="(value) => alguno_seleccionado = value"
                                @cargado="$emit('cargado')"
                                @validoAsientos="(data) => asientos_validos = data"
                            />
                        </template>
                    </div>
                    <div v-else>
                        <p class="oswald text-uppercase mt-lg-4">
                            {{ $t(esReservaInstalaciones ? 'partido.numero_reservas' : 'partido.numero_entradas', { entradas: footer.termino_entradas }) }}
                        </p>
                        <div class="form-group">
                            <multiselect
                                v-model="n_entradas"
                                :placeholder="$t(esReservaInstalaciones ? 'partido.numero_reservas' : 'partido.numero_entradas', { entradas: footer.termino_entradas })"
                                :show-labels="false"
                                :options="options"
                                :allow-empty="false"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <AvisoAsientoOcupado @close="closeModalAsientoOcupado" />
        </div>
        <div class="container" v-else-if="event.place.tipo_proceso_online === 3">
            <div class="row">
                <div class="col-12">
                    <ButacasPlanoGeneral
                        :event="event"
                        :recinto_id="event.place.id"
                        :continuarConCompra="continuarConCompra"
                        :configuracion="configuracion"
                        :resetButacas="resetButacas"
                        :bloquearPaso="bloquear_paso_butacas"
                        :loadingPasoDos="loading"
                        :max_asientos="asientos_maximos"
                        @continuarCompra="(butacas) => $emit('bloquearButacas', butacas)"
                        @setAsientos="(asientos) => $emit('continuarCompraSinNumerar', asientos)"
                        @resetContinuarConCompra="() => $emit('resetContinuarConCompra')"
                    />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import ImagenPanoramica from "@/components/common/ImagenPanoramica";
    import SelectorZonaComponent from '@/components/frontend/events/compra/SelectorZonaComponent';
    import TusAsientosComponent from '@/components/frontend/events/compra/TusAsientosComponent';
    import AsientosComponent from '@/components/frontend/events/compra/AsientosComponent';
    import AsientosLfpComponent from '@/components/frontend/events/compra/AsientosLfpComponent';
    import AvisoAsientoOcupado from '@/components/frontend/events/compra/components/modals/AvisoAsientoOcupado';
    import ButacasPlanoGeneral from './ButacasPlanoGeneral';

    import { TEATRO_HASH_RESERVA_INSTALACIONES } from '@/constants/teatros';

    export default {
        props: {
            zona: {
                type: Object,
                required: false
            },
            zonas: {
                type: Array,
                required: false
            },
            paso2_loading: {
                type: Boolean,
                default: false
            },
            paso3: {
                type: Boolean,
                default: false
            },
            asientos: {
                type: Array,
                required: true
            },
            event: {
                type: Object,
                required: true
            },
            error_message: {
                type: String,
                required: true
            },
            asientos_maximos: {
                type: Number,
                required: true,
            },
            pasoExtraRA: {
                type: Boolean,
                required: true
            },
            loading: {
                type: Boolean,
                required: true
            },
            continuarConCompra: {
                type: Boolean,
                required: true
            },
            configuracion: {
                type: Object,
                required: true
            },
            resetButacas: {
                type: Number,
                required: true
            },
            bloquear_paso_butacas: {
                type: Boolean,
                required: true
            },
        },
        emits: ['bloquearAsientos', 'closeModalAsientoOcupado', 'reset', 'cargado', 'bloquearButacas', 'setAsientos',
                'setZona', 'continuarCompraSinNumerar', 'resetContinuarConCompra'],
        data() {
            return {
                alguno_seleccionado: false,
                asientos_validos: true,
                reloadComponent: 1,
                n_entradas: 0,
                regionSeleccionada: null
            }
        },
        watch: {
            n_entradas() {
                var datos = [];
                for (var i = 0; i < this.n_entradas; i++) {
                    datos.push({
                        'apellidos': '',
                        'asiento': {
                            'zona_id': this.zona.id,
                            'asiento': 0,
                            'fila': 0,
                            'zona_nombre': this.zona.name ?? this.zona.nombre
                        },
                        'dni': '',
                        'es_nuevo': true,
                        'nombre': '',
                        'precio': null,
                        'precios': this.zona.precios,
                        'telefono': '',
                        'url_imprimir': ''
                    });
                }

                this.$emit('setAsientos', datos);
            },
        },
        computed: {
            esReservaInstalaciones() {
                return this.configuracion?.hash_teatro === TEATRO_HASH_RESERVA_INSTALACIONES;
            },
            footer() {
                return this.$store.getters.getFooter;
            },
            entradas_disponibles() {
                if(this.zona.libres > 0) {
                    return this.zona.libres;
                }

                return this.zona.aforo - this.zona.confirmados - this.zona.no_confirmados;
            },
            options() {
                var tope = this.asientos_maximos;

                if(this.entradas_disponibles < tope) {
                    tope = this.entradas_disponibles;
                }

                var opciones = [];

                for(var i = 1; i <= tope; i++) {
                    opciones.push(i);
                }

                return opciones;
            },
        },
        methods: {
            showModal(modal)  {
                this.$modal.show(modal)
            },
            closeModalAsientoOcupado() {
                this.$emit('closeModalAsientoOcupado');
                this.reloadComponent++;
            },
        },
        components: {
            ImagenPanoramica, SelectorZonaComponent, TusAsientosComponent, AsientosComponent, AsientosLfpComponent,
            AvisoAsientoOcupado, ButacasPlanoGeneral
        }
    }
</script>